import React from "react";

const SAMPLE_WIDTH = 820;
const SAMPLE_HEIGHT = 540;

const EventPitchBaseLayer = ({ fieldWidth, fieldHeight, fieldPadding = 0 }) => {
  const scaleX = fieldWidth / SAMPLE_WIDTH;
  const scaleY = fieldHeight / SAMPLE_HEIGHT;
  const scale = Math.min(scaleX, scaleY);

  const px = (value) => fieldPadding + value * scaleX;
  const py = (value) => fieldPadding + value * scaleY;
  const sw = (value) => value * scaleX;
  const sh = (value) => value * scaleY;
  const sr = (value) => value * scale;

  return (
    <g>
      <rect className="pitch-line" x={px(20)} y={py(20)} width={sw(780)} height={sh(500)} />
      <line className="pitch-line" x1={px(410)} y1={py(20)} x2={px(410)} y2={py(520)} />
      <circle className="pitch-line" cx={px(410)} cy={py(270)} r={sr(68)} />
      <circle className="pitch-spot" cx={px(410)} cy={py(270)} r={Math.max(1.5, sr(3))} />

      <rect className="pitch-line" x={px(20)} y={py(150)} width={sw(130)} height={sh(240)} />
      <rect className="pitch-line" x={px(20)} y={py(210)} width={sw(45)} height={sh(120)} />
      <rect className="pitch-line" x={px(5)} y={py(228)} width={sw(15)} height={sh(84)} />
      <path
        className="pitch-line"
        d={`M ${px(150)} ${py(200)} A ${sr(68)} ${sr(68)} 0 0 1 ${px(150)} ${py(340)}`}
      />

      <rect className="pitch-line" x={px(670)} y={py(150)} width={sw(130)} height={sh(240)} />
      <rect className="pitch-line" x={px(755)} y={py(210)} width={sw(45)} height={sh(120)} />
      <rect className="pitch-line" x={px(800)} y={py(228)} width={sw(15)} height={sh(84)} />
      <path
        className="pitch-line"
        d={`M ${px(670)} ${py(200)} A ${sr(68)} ${sr(68)} 0 0 0 ${px(670)} ${py(340)}`}
      />
    </g>
  );
};

export default EventPitchBaseLayer;
